import React from 'react'
import './user-info.scss'
import { data } from '../../constants'

const UserInfo = (props) => {
    console.log('USER INFOOOO')
    console.log(props.img)
    return (
        <div className='user-info'>
            <div className="user-info__img">
                <img src={props.img == data.urls.urlUpload || props.img == `${data.urls.urlUpload}undefined`? props.defaultImg : props.img} alt="" />
                {/* <img src={props.img == data.urls.urlUpload || `${data.urls.urlUpload}undefined` ? props.defaultImg : props.img} alt="" /> */}
            </div>
            <div className="user-info__name">
                <span>{props.user} - {props.rol == 5150 ? 'ADMIN' : "ODONTÓLOGO"}</span>
                {/* <span>{props.user}</span> */}
            </div>
        </div>
    )
}

export default UserInfo
